import React, { FC } from 'react';
import { koenigsburgTileCount } from '../../config/tileMapConfig';
import classes from './Guide.module.scss';
import KGuideTileItem from './KGuideTileItem';

const KoenigsbourgGuide: FC = () => {
  return (
    <>
      <p>
        <span>Koenigsbourg</span> is a Euro-style board game. The main mechanisms are: tile placement, worker placement,
        connections.
      </p>

      <p>
        <span>Goal</span> - players are lords in medieval Alsace and try to dominate cities by building resources and
        collecting the received tokens to those cities.
        <br /> Player scores are only calculated at the very end of the game.
        <br /> For each dominated city the winner in that city get as many points as the number of its gates. So the
        King&apos;s castle scores 6 points as it has 6 gates (roads).
      </p>

      <p>
        <span>Rhombus tiles</span>
      </p>
      <div className={classes.tileList}>
        {koenigsburgTileCount.koenigsburg_rhombus.map((tc) => (
          <KGuideTileItem key={tc} tc={tc} shape={'rhombus'} />
        ))}
      </div>

      <p>
        <span>Triangle tiles</span>
      </p>
      <div className={classes.tileList}>
        {koenigsburgTileCount.koenigsburg_triangle.map((tc) => (
          <KGuideTileItem key={tc} tc={tc} shape={'triangle'} />
        ))}
      </div>

      <p>
        <span>Hexa tiles</span>
      </p>
      <div className={classes.tileList}>
        {koenigsburgTileCount.koenigsburg_hexa.map((tc) => (
          <KGuideTileItem key={tc} tc={tc} shape={'hexa'} />
        ))}
      </div>

      <p>
        <span>Start</span>
      </p>
      <p>
        {' '}
        When the game starts the kings castle - the one with orange background - is already placed on the board. Each
        player has 3 random city tiles turned face down.
      </p>

      <p>
        <span>Core loop</span>
      </p>
      <p>
        In each turn a player can perform 3 possible actions or steps - these are performed sequentially, one after the
        other: <br />
        <ol>
          <li>
            <span>place the 3 randomly pulled tiles</span> on the board to build resources
            <ul>
              <li>1 rhombus shaped tile: this always contains a resource point </li>
              <ul>
                <li> currently the only resource type is forest</li>
                <li> you can place a meeple on a resource point to claim it</li>
                <li>
                  {' '}
                  when the forest is complete you get 2 tokens for each resource point that you claimed - irregardless
                  of the size of the forest
                </li>
              </ul>
              <li>2 triangle shaped tiles - they contain road and forest</li>
              <li>
                optionally you can also place one of your city tiles - hexa shaped:
                <ul>
                  <li>you have 3 of them and you can randomly turn one during your turn</li>
                  <li>
                    you cannot directly place a meeple on a city to dominate it - you need to aquire tokens and bring
                    them into the city
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <span>harvest tokens</span> for completed resource into a connected city:
            <ul>
              <li>
                when a resource is completed you get back the meeples on it and you receive 2 tokens{' '}
                <span>for each resource point</span> that you claimed
              </li>
              <li>
                if there is at least one connected city you must bring the tokens to one of them - this is compulsory,
                you cannot skip it
              </li>
              <li>
                tokens cannot pass forests - to collect the token it needs to connect to the city by a road that
                doesn&apos;t cross a forest
              </li>
              <li>if theres is no connected city you will have to this later when it becomes connected</li>
              <li>this and the next steps are omitted if there are new completed resources</li>
            </ul>
          </li>
          <li>
            <span>place a toll collector</span> meeple next to a city gate - optional:
            <ul>
              <li>you can place a toll collector to a city gate to receive extra tokens for other players tokens</li>
              <li>
                you can only place a toll collector on a city gate after having brought at least one token through that
                gate
              </li>
              <li>after this you receive a 50% toll after other players tokens that go through that gate</li>
              <li>
                the toll collector meeple remains there until all connected and claimed resources are collected - e.g.
                until no more toll could be possibly collected on that gate
              </li>
            </ul>
          </li>
        </ol>
      </p>

      <p>
        Skipping step 1 (tile placement) will skip the other 2 steps as well and the tiles are pushed back to the bag.
        Control is passed to the next player. Skipping step 2 is not allowed if you have complete resources. Step 3 is
        optional so it can be always skipped.
      </p>
      <p>
        <span>End of game</span>
      </p>
      <p>The game ends when all triangle and rhombus tiles are placed - regardless of the unused city tiles.</p>
      <p>
        At the end of the game only the tokens in the cities count. So all uncollected tokens are lost. <br />
        In each city only the winner scores - so he/she recieves as many points as the number of the city gates, the
        other players get nothing.
        <br />
        The kings castle scores like the cities.
      </p>
    </>
  );
};

export default KoenigsbourgGuide;
